<template>
  <div>
    <Toast class="toast-msg" position="bottom-right" />
    <div class="closepass-button">
      <Button
        @click="pushBack"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-plain"
      />
    </div>
    <div v-if="this.isLoading" class="choosen-order__info-skeleton-wrapper">
      <Skeleton
        class="choosen-order__info-skeleton __title"
        width="200px"
        height="24px"
      />
      <Skeleton
        class="choosen-order__info-skeleton__name"
        width="240px"
        height="22px"
      />
      <div class="choosen-order__info-skeleton__item-wrapper">
        <Skeleton
          class="choosen-order__info-skeleton__item"
          width="190px"
          height="25px"
        />
        <Skeleton
          class="choosen-order__info-skeleton__item"
          width="150px"
          height="36px"
        />
      </div>
      <div class="choosen-order__info-skeleton__item-wrapper">
        <Skeleton
          class="choosen-order__info-skeleton__item"
          width="190px"
          height="25px"
        />
        <Skeleton
          class="choosen-order__info-skeleton__item"
          width="150px"
          height="36px"
        />
      </div>
      <div class="choosen-order__info-skeleton__item-wrapper">
        <Skeleton
          class="choosen-order__info-skeleton__item"
          width="190px"
          height="25px"
        />
        <Skeleton
          class="choosen-order__info-skeleton__item"
          width="150px"
          height="36px"
        />
      </div>
    </div>
    <div v-else>
      <h2 class="choosen-order__info-tickets__header">Билеты и услуги</h2>
      
      <div
        class="choosen-order__info-tickets__wrapper"
        v-for="(ticket, index) in this.orderDocs.order.Passengers"
        :key="index"
      >
        <p class="choosen-order__info-tickets__title">
          {{
            ticket.LastName + " " + ticket.FirstName + " " + ticket.MiddleName
          }}
        </p>
        <p v-if="ticket.Tickets.length == 0" class="choosen-order__info-tickets__empty">
        Билеты не найдены.
        </p>
        <div v-else-if="ticket.Tickets[0].State != 10" class="choosen-order__info-tickets__ticket">
          <div class="choosen-order__info-tickets__ticket-num">
            <div class="choosen-order__info-tickets__ticket-num__wrapper">
              <img
                :src="require(`../assets/images/boarding-pass.svg`)"
                alt=""
                class="choosen-order__info-tickets__ticket-num__icon"
              />
              <p
                @click="copyTicket(ticket.Tickets[0].Number)"
                class="choosen-order__info-tickets__ticket-num__value"
              >
                {{ ticket.Tickets[0].Number }}
              </p>
            </div>
            <OnClickOutside @trigger="onClickAwayTicket(index)">
              <div class="choosen-order__info-tickets__ticket-num__btn">
                <button
                  class="ticket-num__btn-status p-ripple"
                  type="button"
                  @click="optnTicketOpen[index] = !optnTicketOpen[index]"
                  v-ripple
                >
                  <span class="ticket-num__btn-status__text">{{
                    getTicketStatus(ticket.Tickets[0].State)
                  }}</span>
                  <img
                    :src="require(`../assets/images/dropdown.svg`)"
                    alt=""
                    class="ticket-num__btn-select__icon"
                  />
                </button>

                <div
                  class="ticket-num__btn-options"
                  :class="{ optionsopened: optnTicketOpen[index] }"
                >
                  <div
                    class="ticket-num__btn-options__save"
                    @click="ticketSave(this.order)"
                  >
                    <img
                      :src="require(`../assets/images/save.svg`)"
                      alt=""
                      class="ticket-num__btn-options__save-icon"
                    />
                    <p>Скачать</p>
                  </div>
                  <div class="ticket-num__btn-options__change">
                    <img
                      :src="require(`../assets/images/exchange.svg`)"
                      alt=""
                      class="ticket-num__btn-options__change-icon"
                    />
                    <router-link
                      :to="{
                        name: 'Support',
                        params: {
                          orderNum: ticket.Tickets[0].Number,
                          guid: this.order,
                          orderId: this.orderDocs.order.Id,
                          mail: this.getRequesterMail(),
                          lastName: ticket.LastName,
                          middleName: ticket.MiddleName,
                          firstName: ticket.FirstName,
                          route: this.route,
                          reason: 'change',
                        },
                      }"
                      class="ticket-num__btn-options__change-link"
                      >Обменять</router-link
                    >
                  </div>
                  <div class="ticket-num__btn-options__change" v-if="ticket.Tickets[0].Number.startsWith('25O-') == false">
                    <img
                      :src="require(`../assets/images/return.svg`)"
                      alt=""
                      class="ticket-num__btn-options__change-icon"
                    />
                    <router-link
                      :to="{
                        name: 'Refund',
                        params: {
                          pnr: this.pnr,
                          guid: this.order,
                          ticketNumber: ticket.Tickets[0].Number.replace(
                            /-/g,
                            ''
                          ),
                        },
                      }"
                      class="ticket-num__btn-options__change-link"
                      >Вернуть</router-link
                    >
                  </div>
                  <div class="ticket-num__btn-options__change">
                    <img
                      :src="require(`../assets/images/edit.svg`)"
                      alt=""
                      class="ticket-num__btn-options__change-icon"
                    />
                    <router-link
                      :to="{
                        name: 'Support',
                        params: {
                          mail: this.getRequesterMail(),
                          orderNum: ticket.Tickets[0].Number,
                          guid: this.order,
                          orderId: this.orderDocs.order.Id,
                          lastName: ticket.LastName,
                          middleName: ticket.MiddleName,
                          firstName: ticket.FirstName,
                          phone: this.orderDocs.order.Phone.Number,
                          birthDate: ticket.BirthDate,
                          docNum: ticket.PassengerDocument.DocNum,
                          docDate: this.getDotDate(
                            ticket.PassengerDocument.ExpirationDate
                          ),
                          reason: 'adjustment',
                        },
                      }"
                      class="ticket-num__btn-options__change-link"
                      >Корректировка</router-link
                    >
                  </div>
                  <div class="ticket-num__btn-options__change">
                    <img
                      :src="require(`../assets/images/lost.svg`)"
                      alt=""
                      class="ticket-num__btn-options__change-icon"
                    />
                    <router-link
                      :to="{
                        name: 'Support',
                        params: {
                          mail: this.getRequesterMail(),
                          orderNum: ticket.Tickets[0].Number,
                          guid: this.order,
                          orderId: this.orderDocs.order.Id,
                          lastName: ticket.LastName,
                          middleName: ticket.MiddleName,
                          firstName: ticket.FirstName,
                          phone: this.orderDocs.order.Phone.Number,
                          reason: 'notdeliv',
                        },
                      }"
                      class="ticket-num__btn-options__change-link"
                      >Не пришёл билет</router-link
                    >
                  </div>
                  <div class="ticket-num__btn-options__change">
                    <img
                      :src="require(`../assets/images/baggage.svg`)"
                      alt=""
                      class="ticket-num__btn-options__change-icon"
                    />
                    <router-link
                      :to="{
                        name: 'Support',
                        params: {
                          mail: this.getRequesterMail(),
                          orderNum: ticket.Tickets[0].Number,
                          guid: this.order,
                          orderId: this.orderDocs.order.Id,
                          lastName: ticket.LastName,
                          middleName: ticket.MiddleName,
                          firstName: ticket.FirstName,
                          phone: this.orderDocs.order.Phone.Number,
                          reason: 'baggage',
                        },
                      }"
                      class="ticket-num__btn-options__change-link"
                      >Дополнительный багаж</router-link
                    >
                  </div>
                  <div class="ticket-num__btn-options__change">
                    <img
                      :src="require(`../assets/images/dog.svg`)"
                      alt=""
                      class="ticket-num__btn-options__change-icon"
                    />
                    <router-link
                      :to="{
                        name: 'Support',
                        params: {
                          mail: this.getRequesterMail(),
                          orderNum: ticket.Tickets[0].Number,
                          guid: this.order,
                          orderId: this.orderDocs.order.Id,
                          lastName: ticket.LastName,
                          middleName: ticket.MiddleName,
                          firstName: ticket.FirstName,
                          phone: this.orderDocs.order.Phone.Number,
                          reason: 'creature',
                        },
                      }"
                      class="ticket-num__btn-options__change-link"
                      >Запрос на перевозку животного</router-link
                    >
                  </div>
                  <div class="ticket-num__btn-options__change">
                    <img
                      :src="require(`../assets/images/smiling-baby.svg`)"
                      alt=""
                      class="ticket-num__btn-options__change-icon"
                    />
                    <router-link
                      :to="{
                        name: 'Support',
                        params: {
                          mail: this.getRequesterMail(),
                          orderNum: ticket.Tickets[0].Number,
                          lastName: ticket.LastName,
                          middleName: ticket.MiddleName,
                          firstName: ticket.FirstName,
                          guid: this.order,
                          orderId: this.orderDocs.order.Id,
                          reason: 'kid',
                        },
                      }"
                      class="ticket-num__btn-options__change-link"
                      >Оформление билета для ребенка</router-link
                    >
                  </div>
                </div>
              </div>
            </OnClickOutside>
          </div>
          <div
            class="choosen-order__info-tickets__ticket-insur"
            v-if="ticket.Insurance.length > 0"
          >
            <div class="choosen-order__info-tickets__ticket-insur__wrapper">
              <img
                :src="require(`../assets/images/life-insurance.svg`)"
                alt=""
                class="choosen-order__info-tickets__ticket-insur__icon"
              />
              <p
                @click="
                  copyInsur(
                    ticket.Insurance[0].FullNumber
                  )
                "
                class="choosen-order__info-tickets__ticket-insur__value"
              >
                {{ ticket.Insurance[0].FullNumber }}
              </p>
            </div>
            <OnClickOutside @trigger="onClickAwayInsur(index)">
              <div class="choosen-order__info-tickets__ticket-num__btn">
                <button
                  class="ticket-num__btn-status p-ripple"
                  type="button"
                  v-ripple
                  @click="optnInsurOpen[index] = !optnInsurOpen[index]"
                >
                  <span class="ticket-num__btn-status__text">{{
                    getTicketStatus(ticket.Tickets[0].State)
                  }}</span>
                  <img
                    :src="require(`../assets/images/dropdown.svg`)"
                    alt=""
                    class="ticket-num__btn-select__icon"
                  />
                </button>

                <div
                  class="ticket-num__btn-options"
                  :class="{ optionsopened: optnInsurOpen[index] }"
                >
                  <div
                    class="ticket-num__btn-options__save"
                    @click="insurSave(ticket.Insurance[0].Url)"
                  >
                    <img
                      :src="require(`../assets/images/save.svg`)"
                      alt=""
                      class="ticket-num__btn-options__save-icon"
                    />
                    <p>Скачать</p>
                  </div>
                </div>
              </div>
            </OnClickOutside>
          </div>

          <div
            v-if="ticket.Taxes.length > 0"
            class="choosen-order__info-tickets__ticket-tax"
          >
            <div class="choosen-order__info-tickets__ticket-insur__wrapper">
              <img
                :src="require(`../assets/images/tax.svg`)"
                alt=""
                class="choosen-order__info-tickets__ticket-tax__icon"
              />
              <p
                @click="copyTaxes(ticket.Taxes[0].DocNumber)"
                class="choosen-order__info-tickets__ticket-tax__value"
              >
                {{ ticket.Taxes[0].DocNumber }}
              </p>
            </div>
            <OnClickOutside @trigger="onClickAwayTax(index)">
              <div class="choosen-order__info-tickets__ticket-num__btn">
                <button
                  class="ticket-num__btn-status p-ripple"
                  type="button"
                  v-ripple
                  @click="optnTaxOpen[index] = !optnTaxOpen[index]"
                >
                  <span class="ticket-num__btn-status__text">{{
                    getTicketStatus(ticket.Tickets[0].State)
                  }}</span>
                  <img
                    :src="require(`../assets/images/dropdown.svg`)"
                    alt=""
                    class="ticket-num__btn-select__icon"
                  />
                </button>

                <div
                  class="ticket-num__btn-options"
                  :class="{ optionsopened: optnTaxOpen[index] }"
                >
                  <div
                    class="ticket-num__btn-options__save"
                    @click="taxSave(this.order)"
                  >
                    <img
                      :src="require(`../assets/images/save.svg`)"
                      alt=""
                      class="ticket-num__btn-options__save-icon"
                    />
                    <p>Скачать</p>
                  </div>
                </div>
              </div>
            </OnClickOutside>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ref } from "vue";
import useClipboard from "vue-clipboard3";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { OnClickOutside } from "@vueuse/components";
import Ripple from "primevue/ripple";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
import OrderDocsModel from "../models/OrderDocsModel";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "RouteCardInfo",
  components: {
    Button,
    Skeleton,
    OnClickOutside,
    Toast,
  },
  props: ["order", "guid", "orderId", "mail", "phone", "route", "pnr"],
  setup(props) {
    const toast = useToast();
    const { toClipboard } = useClipboard();
    const isLoading = ref(false);
    const error = ref(null);
    const router = useRouter();
    const route = useRoute();
    const orderDocs = ref<OrderDocsModel | null>(null);
    const showSuccess = () => {
      toast.add({
        severity: "success",
        summary: "Скопировано",
        detail: "в буфер обмена",
        life: 3000,
      });
    };
    const getOrderDocs = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetOrderPassengers?guid=${props.order}`
        );
        let fetchedPass = await json.data;
        orderDocs.value = fetchedPass;
        console.log(orderDocs.value);
        
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    const copyTicket = async (item: any) => {
      try {
        if (orderDocs.value !== null) {
          let copyString: string = item;
          await toClipboard(copyString);
          showSuccess();
        }
      } catch (e) {
        console.error(e);
      }
    };
    const copyInsur = async (item: any) => {
      try {
        if (orderDocs.value !== null) {
          let copyString: string = item;
          await toClipboard(copyString);
          showSuccess();
        }
      } catch (e) {
        console.error(e);
      }
    };
    const copyTaxes = async (item: any) => {
      try {
        if (orderDocs.value !== null) {
          let copyString: string = item;
          await toClipboard(copyString);
          showSuccess();
        }
      } catch (e) {
        console.error(e);
      }
    };
    return {
      isLoading,
      error,
      orderDocs,
      getOrderDocs,
      copyTicket,
      copyInsur,
      copyTaxes,
    };
  },
  data() {
    return {
      optnInsurOpen: [false, false, false, false, false, false, false, false],
      optnTaxOpen: [false, false, false, false, false, false, false, false],
      optnTicketOpen: [false, false, false, false, false, false, false, false],
      visibleTickets: false,
    };
  },
  methods: {
    getRequesterMail() {
      let mailInfo = sessionStorage.getItem("userName");
      let mail;
      if (mailInfo) {
        mail = JSON.parse(mailInfo);
        return mail;
      } else {
        return "";
      }
    },
    getDotDate(date: any) {
      let dotDate;
      let fullDate = new Date(date);
      let day = fullDate.getDate();
      let month = fullDate.getMonth();
      let fullMonth;
      let year = fullDate.getFullYear();
      if (month < 10) {
        fullMonth = "0" + month;
      } else {
        fullMonth = month;
      }
      dotDate = day + "." + fullMonth + "." + year;
      return dotDate;
    },
    ticketSave(num: any) {
      window.location.href = `https://bo.biletdv.ru/api/ShowITR/guid/${num}/type/itinerary`;
    },
    insurSave(url: any) {
      window.location.href = url;
    },
    taxSave(num: any) {
      window.location.href = `https://bo.biletdv.ru/api/ShowITR/guid/${num}/type/tax`;
    },
    onClickAwayTicket(index: any) {
      this.optnTicketOpen[index] = false;
    },
    onClickAwayInsur(index: any) {
      this.optnInsurOpen[index] = false;
    },
    onClickAwayTax(index: any) {
      this.optnTaxOpen[index] = false;
    },
    getTicketStatus(state: number) {
      if (state == 10) {
        return "Создан";
      } else if (state == 20) {
        return "Выпущен";
      } else if (state == 30) {
        return "Аннулирован";
      } else if (state == 40) {
        return "Возвращен";
      } else if (state == 50) {
        return "Обменян";
      }
    },
    pushBack() {
      this.$router.back();
    },
  },
  created() {
    this.getOrderDocs();
  },
  directives: {
    ripple: Ripple,
  },
});
</script>

<style>
.choosen-order__info-skeleton__name {
  margin-top: 20px;
}

.choosen-order__info-tickets__empty {
  margin-top: 15px;
  background-color: #fff;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 3px;
      overflow: hidden;
      padding: 10px;
}

.choosen-order__info-skeleton__item-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}

.choosen-order__info-skeleton__item {
  margin-top: 12px;
}
</style>
